import Portfolio from "../../../commonComponents/portfolio";

const PortfolioImageChangeContainer = () => {
  return <Portfolio type="image_change" gridSize={3} carShow={9} />;
};

export default PortfolioImageChangeContainer;
